import { environment } from './environment'

// NOTION PAGES
export const NOTION_FAQ = '4ed5366ea478471b80bc136f9641a4fa'
export const NOTION_HYPETEAM = '4cbc27953e3749819e20e8c47061ca01'
export const NOTION_OVERVIEW = '3f7c4c58b26a4e70834791ab8e5c0691'
export const NOTION_WAITLISTFAQ = '8962942576794c17b263c6b581bb7468'
export const NOTION_LEGAL = '5ec9cdbd0c7d4fbe909b65ac19228b41'

// INTERNAL LINKS
export const REFERRAL_BASE_URL = `${environment.appUrl}/signup?referral_id=`
export const AFFILIATE_BASE_URL = `https://insiders.creatorland.com/?affiliate_id=`

// EXTERNALS LINKS
export const COLLAB_BASE_URL =
  'https://ho4rn5p6amc.typeform.com/to/r2uYvZ5J#username='
export const UPDATE_PROFILE_BASE_URL =
  'https://ho4rn5p6amc.typeform.com/updateprofile#email='
export const TWITTER_NEW_TWEET = 'https://twitter.com/intent/tweet?text='

export const CREATORLAND_SOCIALS = {
  instagram: 'https://www.instagram.com/realcreatorland',
  twitter: 'https://twitter.com/realcreatorland',
  tiktok: 'https://www.tiktok.com/@creatorland',
  youtube: 'https://www.youtube.com/@creatorlandTV',
  linkedin: 'https://www.linkedin.com/company/creatorland',
  discord: '/discord',
}

export const CREATORLAND_TWITTER_USERNAME = '@realcreatorland'

export const APP_URLS = [
  // {
  //   name: 'Feed',
  //   url: '/',
  // },
  // {
  //   name: 'Groups',
  //   url: '/feed',
  // },
  // {
  //   name: 'Collabs',
  //   url: '/collabs',
  // },
  // {
  //   name: 'Inbox',
  //   url: '/inbox',
  // },
  {
    name: 'Profile',
    url: '/',
  },
  // {
  //   name: 'Notifications',
  //   url: '/notifications',
  // },
  // {
  //   name: 'Search',
  //   url: '/search',
  // },
  // {
  //   name: 'Settings',
  //   url: '/settings',
  // },
  {
    name: 'Log Out',
    url: '/logout',
    rule: 'isAuthenticated',
  },
  {
    name: 'Log In',
    url: '/login',
    rule: 'isNotAuthenticated',
  },
]
